<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'complete-account.account' | translate}}
  </div>
  <div class="form-container">
    <form [formGroup]="completeAccountForm" class="form">
      <app-input 
        [label]="'labels.first_name' | translate"
        [placeholder]="'placeholders.first_name' | translate"
        [formControl]="firstNameControl"
        type="text"
      ></app-input>
      
      <app-input 
        [label]="'labels.last_name' | translate"
        [placeholder]="'placeholders.last_name' | translate"
        [formControl]="lastNameControl"
        type="text"
      ></app-input>

      <app-input 
        [label]="'labels.birthdate' | translate"
        [placeholder]="'placeholders.birthdate' | translate"
        [formControl]="birthdateControl"
        type="date"
      ></app-input>

      <div class="phone-container">
        <img src="/imgs/wapp_logo.png" alt="">
        <p>{{ 'complete-account.wapp' | translate }}</p>
        
        <p class="label">{{ 'labels.country_code' | translate }}</p>
        <mat-form-field appearance="outline">
          <mat-select [formControl]="dialCodeControl" >
            @for (group of COUNTRY_GROUPS; track group.name) {
              <mat-optgroup [label]="group.name | translate">
                @for (item of sortCountriesByTranslatedName(group.countries); track item.iso) {
                  <mat-option [value]="item.dial_code">{{item.name | translate}} {{'('+item.dial_code+')'}}</mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
        @if (
          dialCodeControl.invalid 
          && dialCodeControl.errors
          && (dialCodeControl.touched || dialCodeControl.dirty)
        ) {
          @if (dialCodeControl.errors['required']) {
            <div class="error">
              {{ 'errors.field_required' | translate }}
            </div>
          } @else {
            <div class="error">
              {{ 'errors.invalid_field' | translate }}
            </div>
          }
        }

        <app-input 
          [label]="'labels.phone' | translate"
          [placeholder]="'placeholders.phone' | translate"
          [formControl]="phoneNumberControl"
          type="tel"
        ></app-input>
      </div>
      
      <div class="divider"></div>

      <div class="checks-container-psychologist">
        <mat-checkbox 
          class="custom-checkbox" 
          [class.required]="psychologistCheckControl.invalid 
            && (psychologistCheckControl.touched || psychologistCheckControl.dirty)"
          [formControl]="psychologistCheckControl">
            {{'labels.want_to_request_psychologist_provide' | translate}}
        </mat-checkbox>
        <p>{{'labels.check_as_professional' | translate}}</p>
      </div>
        
      <div class="divider"></div>      

      <div class="checks-container">        
        <mat-checkbox 
          class="custom-checkbox" 
          [class.required]="termsAndConditionsCheckControl.invalid 
            && (termsAndConditionsCheckControl.touched || termsAndConditionsCheckControl.dirty)"
          [formControl]="termsAndConditionsCheckControl">
            {{'labels.terms_and_conditions' | translate}}
        </mat-checkbox>
        <p (click)="goToTermsAndConditions()">{{'labels.read_terms_and_conditions' | translate}}</p>

        <mat-checkbox 
          class="custom-checkbox" 
          [class.required]="privacyPoliciesCheckControl.invalid 
            && (privacyPoliciesCheckControl.touched || privacyPoliciesCheckControl.dirty)"  
          [formControl]="privacyPoliciesCheckControl">
          {{'labels.privacy_policies' | translate}}
        </mat-checkbox>
        <p (click)="goToPrivacyPolicies()">{{'labels.read_privacy_policies' | translate}}</p>
      </div>

      <div class="divider"></div>
    </form>

    <div class="actions-container">
      <app-button
        [buttonLabel]="'buttons.save' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="isFormInvalid()"
        (click)="saveAccount()">
      </app-button>
    </div>
    
  </div>
</div>